/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/prop-types */
// @ts-nocheck

import './App.css'

import CssBaseline from '@material-ui/core/CssBaseline'
import { install } from 'ga-gtag'
import React, { FC, useEffect, useState } from 'react'
import TagManager from 'react-gtm-module'
import { connect } from 'react-redux'

import { appAction, fetchServiceProviderCall } from './actions/app.action'
import { countriesCall, masterDataCall } from './actions/masterData.action'
import { fetchChildrenListV1 } from './actions/parent.action'
import { setAxiosBase } from './api/httpClient'
import localStorageService from './api/localStorageService'
import Loader from './components/loader/Loader'
import { selectAuth, selectMetaData, selectUser } from './helpers/selectors'
import { isEmpty, noop, raiseGAEvent } from './helpers/utils'
import Routes from './Routes'
import { AppActionType, CountriesCallType, MasterDataCallType } from './types/actions'
import { RootConfig } from './types/common'

declare global {
  interface Window {
    rootConfig: RootConfig
  }
}

type Props = {
  appAction: AppActionType
  masterDataCall: MasterDataCallType
  countriesCall: CountriesCallType
  loader: boolean
  metadata: any
}

const App: FC<Props> = ({
  appAction,
  masterDataCall,
  countriesCall,
  auth,
  user,
  fetchChildrenListV1,
  fetchServiceProviderCall,
  metadata,
}) => {
  const [configInitialized, setConfigInitialized] = useState(false)
  useEffect(() => {
    appAction({
      baseURL: __SERVICE_URL_SECURED__,
      loginURL: __LOGIN_URL_SECURED__,
      redirectBase: __REDIRECT_BASE_SECURED__,
      recaptchaSiteKey: __RECAPTCHA_SITE_KEY__,
      ferpaHelpUrlBase: __FERPA_HELP_URL_SECURED__,
      adminURL: __ADMIN_URL__,
      adminAuthURL: __ADMIN_AUTH_URL__,
      authorizeSealUrl: __AUTHORIZE_SEAL_URL,
      lmsUrl: __LMS_URL__,
    })
    setAxiosBase({ baseURL: __SERVICE_URL_SECURED__ })
    setConfigInitialized(true)
  }, [])

  useEffect(() => {
    masterDataCall()
    countriesCall({
      q: '',
      sort_by: 'name',
      sort_order: 'asc',
      per_page: 500,
      page: 1,
    })
  }, [])

  useEffect(() => {
    if (!isEmpty(user)) {
      fetchServiceProviderCall()
      localStorageService.setSchoolSurveyToggled(false)
      localStorageService.setParentSchSurveyToggled(false)
    }
  }, [user])

  useEffect(() => {
    if (auth.isLoggedIn && !user.isStudent) {
      fetchChildrenListV1()
    }
  }, [auth.isLoggedIn])

  useEffect(() => {
    if (metadata.ga_enable && user.id && metadata.ga_id) {
      raiseGAEvent('config', metadata.ga_id, {
        user_id: user.id,
      })
    }
  }, [user.id, metadata.ga_id, metadata.ga_enable])

  useEffect(() => {
    if (metadata.ga_enable && metadata.ga_id) {
      install(metadata.ga_id)
    }
  }, [metadata.ga_id, metadata.ga_enable])

  useEffect(() => {
    if (metadata.ga_enable && metadata.gtm_id) {
      TagManager.initialize({
        gtmId: metadata.gtm_id,
      })
    }
  }, [metadata.gtm_id, metadata.ga_enable])

  if (!configInitialized) {
    return <Loader />
  }

  return (
    <>
      <CssBaseline />
      <div className="app">
        <Routes metadata={metadata} />
      </div>
    </>
  )
}

App.defaultProps = {
  appAction: () => noop,
  masterDataCall: () => noop,
  countriesCall: () => noop,
  auth: {},
  user: {},
  fetchChildrenListV1: noop,
  fetchServiceProviderCall: noop,
  metadata: {},
}

const mapStateToProps = (state: any) => ({
  auth: selectAuth(state),
  user: selectUser(state),
  metadata: selectMetaData(state),
})

export default connect<any, any, any>(mapStateToProps, {
  appAction,
  masterDataCall,
  countriesCall,
  fetchChildrenListV1,
  fetchServiceProviderCall,
})(App)
